// {
//   originalUrl: "", // reddit url
//   originalImageUrl: "", // absolute url to original image pre-photoshop
//   uploadUrl: "", // filename of uploaded image in public/images/psbattles/ directory
//   uploadTitle: "Snarky Title" // fun snarky title used as comment on reddit
// }

export const battles = [
  {
    originalUrl: "https://www.reddit.com/r/photoshopbattles/comments/6grwyf/psbattle_little_girl_with_a_water_gun/", // reddit url
    originalImageUrl: "https://i.imgur.com/KvMphmi.png", // absolute url to original image pre-photoshop
    uploadUrl: "pwepare_to_die_20170612.jpg", // filename of uploaded image in public/images/psbattles/ directory
    uploadTitle: "Pwepare to Die" // fun snarky title used as comment on reddit
  }, {
    originalUrl: "https://www.reddit.com/r/photoshopbattles/comments/6ov4fa/psbattle_this_leopard_with_a_fish/",
    originalImageUrl: "https://i.redditmedia.com/tqLRgyxfrBhIu611ailqBFJa2Pc2njTCXkozDsgcM-A.jpg?w=1024&s=fbabde9586c8b6b4097d0a424494cd21",
    uploadUrl: "jaguar_20170722.jpg",
    uploadTitle: "Driving a Leopard"
  }, {
    originalUrl: "https://www.reddit.com/r/photoshopbattles/comments/6sryd5/psbattle_this_reaction_when_he_realize_he_won/",
    originalImageUrl: "https://i.redd.it/qyrdptqadvez.jpg",
    uploadUrl: "headcrab_20170810.jpg",
    uploadTitle: "Gross"
  }
]



// WEBPACK FOOTER //
// ./src/Blog/PhotoshopBattles/battles.js